<div class="overlay"></div>
<div class="container">
  <app-shared-loading *ngIf="loading"></app-shared-loading>
  <div id="ticketDivTC">
    <div class="whiteVoucherBox">
      <p class="topMsg">{{ 'payment-Receipt-Title' | translation | async }}</p>
      <h1 [ngClass]="{ approved: approve, failed: fail, pended: pend }">
        Pago {{ response }}
      </h1>
      <h2>{{ transaction?.MERCHANT_NAME }}</h2>
      <div class="leftInfoVoucher" *ngIf="infoPayment">
        <div *ngIf="beValidaTransaction">
          <p>Fecha: {{ beValidaTransaction?.fecha }}</p>
          <p class="reference">
            <b>Referencia:</b> {{ transaction?.ORDER_REFERENCE }}
          </p>
          <p>Medio de pago: {{ beValidaTransaction?.franquicia }}</p>
          <div class="flexBox">
            <div class="column">
              <b>Total:</b>
            </div>
            <div class="column">
              <b>{{ transaction.ORDER_AMOUT | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
            </div>
          </div>
        </div>
        <div *ngIf="tcReturnTransaction">
          <p>Fecha: {{ tcReturnTransaction?.date }}</p>
          <p class="reference">
            <b>Referencia:</b> {{ transaction?.ORDER_REFERENCE }}
          </p>
          <p>Tarjeta: {{ tcReturnTransaction?.cardNumber }}</p>
          <p>Franquicia: {{ tcReturnTransaction?.franchise }}</p>
          <p *ngIf="tcReturnTransaction?.cus != null && tcReturnTransaction?.numAprobacion == null">Código de
            seguimiento: {{ tcReturnTransaction?.cus }}</p>
          <p *ngIf="tcReturnTransaction?.numAprobacion != null">Código de seguimiento: {{
            tcReturnTransaction?.numAprobacion }}</p>
          <div class="flexBox">
            <div class="column">
              <b>Total:</b>
            </div>
            <div class="column">
              <b>{{ transaction.ORDER_AMOUT | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
            </div>
          </div>
        </div>
        <div *ngIf="pseReturnTransaction">
          <p>Fecha: {{ pseReturnTransaction?.TRANSACTION_DATE }}</p>
          <p class="reference">
            <b>Referencia:</b> {{ transaction?.ORDER_REFERENCE }}
          </p>
          <br />
          <p>Banco: {{ pseReturnTransaction?.BANK }}</p>
          <p>NIT del comercio: {{ pseReturnTransaction?.NIT }}</p>
          <p>CUS: {{ pseReturnTransaction?.TRAZABILITY_CODE }}</p>
          <p>Orden: {{ orderID }}</p>
          <br />
          <div class="flexBox">
            <div class="column">
              <b>Total:</b>
            </div>
            <div class="column">
              <b>{{ transaction.ORDER_AMOUT | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
            </div>
          </div>
        </div>
        <div *ngIf="pColTransaction != null || pColData != null ">
          <p>{{ 'html-Date-Title' | translation | async }}: {{ ptsColTransaction?.date }}</p>
          <p class="reference">
            <b>{{ 'reference-label' | translation | async}}:</b> {{ ptsColTransaction?.reference }}
          </p>
          <div class="pColInfo">
            <p *ngIf="!ptsColTransaction?.remainingAmount">{{ 'pcol-payment-title' | translation | async }}</p>
            <p *ngIf="ptsColTransaction?.remainingAmount">{{ 'split-pcol-payment-title' | translation | async }}</p>
            <p>{{'pcol-points-label' | translation | async}}: {{ transaction.ORDER_CURRENCY }} {{
              ptsColTransaction?.pcolRedeemed | number : '1.2-2' }}</p>
            <p *ngIf="ptsColTransaction?.remainingAmount">{{ 'money-label' | translation | async }}: {{
              transaction.ORDER_CURRENCY }} {{ ptsColTransaction?.remainingAmount | number : '1.2-2' }}</p>
          </div>
          <div class="flexBox">
            <div class="column">
              <b>{{ 'total-label' | translation | async }}:</b>
            </div>
            <div class="column">
              <b>{{ ptsColTransaction.totalAmount | number : '1.2-2' }} {{ transaction.ORDER_CURRENCY }}</b>
            </div>
          </div>
        </div>
      </div>
      <app-generic-button *ngIf="fail" text="Reintentar Pago" (click)="retryPayment()"></app-generic-button>
      <app-buttons-bar [redirect]="redirect" [valid]="true" (PR)="print()"></app-buttons-bar>
      <br>
      <p class="whiteVoucherFooter">{{ 'no-Print-Receipt' | translation | async }}</p>
    </div>
  </div>
  <app-footer></app-footer>
</div>